/**
 * Subtle banner showing today's + upcoming birthdays from People Aura remembers.
 * Auto-hides if there are none. Clicking opens the People list.
 */
export function BirthdaysCard({ birthdays, onOpenPeople, onDismiss }) {
  if (!birthdays || birthdays.length === 0) return null;

  const todayList = birthdays.filter((b) => b.days_until === 0);
  const upcoming = birthdays.filter((b) => b.days_until > 0 && b.days_until <= 7);

  const renderLine = (b) => {
    const rel = b.relationship ? ` (${b.relationship})` : "";
    if (b.days_until === 0) return `${b.name}${rel} — today 🎂`;
    if (b.days_until === 1) return `${b.name}${rel} — tomorrow`;
    return `${b.name}${rel} — in ${b.days_until} days`;
  };

  return (
    <div className="birthdays-card" data-testid="birthdays-card">
      <div className="birthdays-card-head">
        <span className="birthdays-card-title">
          {todayList.length > 0 ? "🎂 Birthday today" : "🎂 Upcoming birthdays"}
        </span>
        <button
          className="birthdays-card-close"
          onClick={onDismiss}
          data-testid="birthdays-card-close"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
      <ul className="birthdays-card-list">
        {todayList.map((b) => (
          <li key={b.person_id} className="birthdays-card-item today">
            {renderLine(b)}
          </li>
        ))}
        {upcoming.slice(0, 3).map((b) => (
          <li key={b.person_id} className="birthdays-card-item">
            {renderLine(b)}
          </li>
        ))}
      </ul>
      <button
        className="birthdays-card-action"
        onClick={onOpenPeople}
        data-testid="birthdays-card-open"
      >
        See your people →
      </button>
    </div>
  );
}
